/**
 * Live margin badge for a menu item: (price − recipe cost) / price.
 * Green ≥60% · Yellow 30–60% · Red <30%. Renders null when there's no
 * linked recipe cost so items without a recipe stay clean.
 */
export function MenuMarginBadge({ price, cost, className = '' }) {
  const p = Number(price || 0);
  if (!p || cost == null) return null;
  const margin = ((p - Number(cost)) / p) * 100;
  const tone = margin >= 60 ? 'emerald' : margin >= 30 ? 'amber' : 'rose';
  const map = {
    emerald: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300',
    amber: 'bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300',
    rose: 'bg-rose-100 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300',
  };
  return (
    <span
      className={`text-[9px] font-bold px-1.5 py-0.5 rounded-full whitespace-nowrap ${map[tone]} ${className}`}
      title={`Margin ${margin.toFixed(0)}% · price ${p.toFixed(2)} − recipe cost ${Number(cost).toFixed(2)}`}
      data-testid={`menu-margin-badge`}
      data-tone={tone}
    >
      {margin.toFixed(0)}% margin
    </span>
  );
}

export default MenuMarginBadge;
